export { DrillPageWordSentencePrompt } from "#drill-page-word-sentence-prompt";
